// fr strings for messages/studioOptions.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studioOptions: Dict = {
  "studioOptions.pitch.title": "Tonalité",
  "studioOptions.pitch.hint":
    "En demi-tons. D'une voix masculine à une voix féminine ? Essaie +12.",
  "studioOptions.pitch.label": "la tonalité de {name}",
  "studioOptions.pitch.maleToFemale": "Masculine → féminine",
  "studioOptions.pitch.femaleToMale": "Féminine → masculine",
  "studioOptions.pitch.original": "Originale",
  "studioOptions.stepper.lower": "Baisser {label}",
  "studioOptions.stepper.raise": "Monter {label}",
  "studioOptions.effect.title": "Effet",
  "studioOptions.effect.hint":
    "Un seul à la fois. Touche-le à nouveau pour le retirer.",
  "studioOptions.effect.none": "Aucun",
  "studioOptions.effect.onVocals": "Sur la voix",
  "studioOptions.effect.onSong": "Sur tout le titre",
  "studioOptions.autotune.title": "Autotune",
  "studioOptions.autotune.switch": "Caler la voix sur la tonalité",
  "studioOptions.autotune.hint":
    "D'une légère retouche au son robotique bien marqué.",
  "studioOptions.autotune.light": "Léger",
  "studioOptions.autotune.medium": "Moyen",
  "studioOptions.autotune.strong": "Fort",
  "studioOptions.mix.title": "Mix",
  "studioOptions.mix.vocalVolume": "Volume de la voix",
  "studioOptions.mix.vocalVolumeHint":
    "Plus fort ou moins fort que la musique, en dB.",
  "studioOptions.mix.vocalVolumeLabel": "le volume de la voix",
  "studioOptions.mix.backing": "Séparer les chœurs",
  "studioOptions.mix.backingHint":
    "Résultat plus propre si le titre a des harmonies ou des ad-libs.",
  "studioOptions.mix.vocalsOnly": "Mon audio contient seulement la voix",
  "studioOptions.mix.vocalsOnlyHint":
    "Saute la séparation de la voix et de la musique.",
  "studioOptions.name.title": "Nom de la cover",
  "studioOptions.name.placeholder": "Facultatif",

  "studioOptions.summary.pitch": "Tonalité {values}",
  "studioOptions.summary.autotune": "Autotune",
  "studioOptions.summary.vocals": "Voix {value}",
  "studioOptions.summary.backing": "Chœurs séparés",
  "studioOptions.summary.vocalsOnly": "Audio voix seule",
  "studioOptions.summary.default": "Tonalité originale, sans effet",

  "studioOptions.video.previewAria": "Aperçu de la Marble Run",
  "studioOptions.video.headline":
    "Tes voix font la course. Celle en tête chante.",
  "studioOptions.video.body":
    "Chaque changement de leader devient un changement de voix, avec les paroles à l'écran. Prêt à poster sur TikTok et Reels.",
  "studioOptions.video.crown": "La couronne montre qui chante",
  "studioOptions.video.pickLook": "Choisis un style",
  "studioOptions.video.customise": "Personnaliser",
  "studioOptions.video.surprise": "Surprends-moi",
  "studioOptions.video.marbles": "Billes et piste",
  "studioOptions.video.sky": "Ciel",
  "studioOptions.video.font": "Police des paroles",
  "studioOptions.video.stars": "Étoiles dans le ciel",
  "studioOptions.theme.midnight": "Minuit",
  "studioOptions.theme.neon": "Néon",
  "studioOptions.theme.ocean": "Océan",
  "studioOptions.theme.royal": "Royal",
  "studioOptions.theme.lava": "Lave",
  "studioOptions.theme.gold": "Or",

  "studioOptions.upload.empty":
    "Ce fichier est vide. Choisis à nouveau le fichier du titre.",
  "studioOptions.upload.tooBig":
    "Le fichier dépasse 75 Mo ! Importe un fichier plus léger.",
  "studioOptions.upload.tooLong":
    "L'audio dépasse 6 minutes ! Importe un fichier plus court.",
  "studioOptions.upload.invalid": "Importe un fichier audio valide",
  "studioOptions.upload.unexpected": "Une erreur inattendue s'est produite.",
  "studioOptions.upload.uploading": "Import en cours...",
  "studioOptions.upload.coverAlt": "pochette",
  "studioOptions.upload.dropIt": "Lâche-le",
  "studioOptions.upload.dropHere": "Dépose ton audio ici",
  "studioOptions.upload.browse": "Parcourir les fichiers",
  "studioOptions.upload.formats": "MP3, WAV ou M4A · 6 minutes max",
  "studioOptions.upload.dropOrBrowse":
    "Dépose un fichier audio ou clique pour parcourir",
  "studioOptions.upload.limits": "75 Mo, 6 min max • MP3, WAV, M4A",

  "studioOptions.mic.denied":
    "Autorise l'accès au micro dans ton navigateur pour enregistrer.",
  "studioOptions.mic.notFound": "Aucun micro trouvé pour enregistrer.",
  "studioOptions.mic.prepareFailed":
    "Impossible de préparer l'emplacement d'import.",
  "studioOptions.mic.fileFailed": "Échec de l'import du fichier.",
  "studioOptions.mic.uploadFailed": "Échec de l'import de l'enregistrement.",
  "studioOptions.mic.previewFailed": "Impossible de lire l'aperçu audio.",
  "studioOptions.mic.start": "Lancer l'enregistrement",
  "studioOptions.mic.stop": "Arrêter l'enregistrement",
  "studioOptions.mic.tapRecord": "Touche pour enregistrer",
  "studioOptions.mic.tapStop": "Touche pour arrêter",
  "studioOptions.mic.clickRecord": "Clique pour enregistrer",
  "studioOptions.mic.processing": "Traitement...",
  "studioOptions.mic.playPreview": "Écouter l'aperçu",
  "studioOptions.mic.pausePreview": "Mettre l'aperçu en pause",
  "studioOptions.mic.yourRecording": "Ton enregistrement",
  "studioOptions.mic.use": "Utiliser cet enregistrement",
  "studioOptions.mic.again": "Recommencer",
  "studioOptions.mic.continue": "Continuer",
};

export default studioOptions;
